import { useState } from 'react'

import { visibleOrdersCount } from '@/RecoveredOrdersPage/constants'

const useVisibleOrders = orders => {
  const [showAll, setShowAll] = useState(false)

  const visibleOrders = showAll ? orders : orders.slice(0, visibleOrdersCount)
  const hasHiddenOrders = !showAll && orders.length > visibleOrdersCount

  const showAllOrders = () => setShowAll(true)

  return { visibleOrders, hasHiddenOrders, showAllOrders }
}

export default useVisibleOrders
